import React, { useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || '';

function KeyChain({ onMenuClick }) {
  const [level, setLevel] = useState('off');
  const [taskEnabled, setTaskEnabled] = useState(true);
  const [taskVisible, setTaskVisible] = useState(true);
  const [streamEnabled, setStreamEnabled] = useState(false);
  const [techKnowledgeEnabled, setTechKnowledgeEnabled] = useState(false);
  const [peekEnabled, setPeekEnabled] = useState(false);
  const [knowledgeEnabled, setKnowledgeEnabled] = useState(true);
  const [memoryEnabled, setMemoryEnabled] = useState(true);
  const [healthEnabled, setHealthEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    fetch(`${API}/api/profile-settings`)
      .then(r => r.json())
      .then(data => {
        const perm = data.find(d => d.key === 'dev_permissions');
        if (perm) setLevel(perm.value || 'off');
        const te = data.find(d => d.key === 'task_enabled');
        if (te) setTaskEnabled(te.value !== 'false');
        const tv = data.find(d => d.key === 'task_visible');
        if (tv) setTaskVisible(tv.value !== 'false');
        const se = data.find(d => d.key === 'stream_enabled');
        if (se) setStreamEnabled(se.value === 'true');
        const tk = data.find(d => d.key === 'tech_knowledge_enabled');
        if (tk) setTechKnowledgeEnabled(tk.value === 'true');
        const pk = data.find(d => d.key === 'peek_enabled');
        if (pk) setPeekEnabled(pk.value === 'true');
        const ke = data.find(d => d.key === 'knowledge_enabled');
        if (ke) setKnowledgeEnabled(ke.value !== 'false');
        const me = data.find(d => d.key === 'memory_enabled');
        if (me) setMemoryEnabled(me.value !== 'false');
        const he = data.find(d => d.key === 'health_enabled');
        if (he) setHealthEnabled(he.value !== 'false');
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const saveSetting = async (key, value) => {
    try {
      await fetch(`${API}/api/profile-settings`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key, value })
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (e) { alert('保存失败'); }
  };

  const saveLevel = (newLevel) => {
    setLevel(newLevel);
    saveSetting('dev_permissions', newLevel);
  };

  const toggleTaskEnabled = () => {
    const newVal = !taskEnabled;
    setTaskEnabled(newVal);
    localStorage.setItem('task_enabled', String(newVal));
    saveSetting('task_enabled', String(newVal));
  };

  const toggleTaskVisible = () => {
    const newVal = !taskVisible;
    setTaskVisible(newVal);
    localStorage.setItem('task_visible', String(newVal));
    saveSetting('task_visible', String(newVal));
  };

  const toggleStreamEnabled = () => {
    const newVal = !streamEnabled;
    setStreamEnabled(newVal);
    saveSetting('stream_enabled', String(newVal));
  };

  const toggleTechKnowledge = () => {
    const newVal = !techKnowledgeEnabled;
    setTechKnowledgeEnabled(newVal);
    saveSetting('tech_knowledge_enabled', String(newVal));
  };

  const togglePeek = () => {
    const newVal = !peekEnabled;
    setPeekEnabled(newVal);
    saveSetting('peek_enabled', String(newVal));
  };

  const toggleKnowledge = () => {
    const newVal = !knowledgeEnabled;
    setKnowledgeEnabled(newVal);
    saveSetting('knowledge_enabled', String(newVal));
  };

  const toggleMemory = () => {
    const newVal = !memoryEnabled;
    setMemoryEnabled(newVal);
    saveSetting('memory_enabled', String(newVal));
  };

  const toggleHealth = () => {
    const newVal = !healthEnabled;
    setHealthEnabled(newVal);
    saveSetting('health_enabled', String(newVal));
  };

  const levels = [
    { key: 'off', icon: '🔒', name: '关闭', sub: '乖乖说话就好，不许乱动', detail: '没有开发工具。只能聊天和使用日记、朋友圈等。', color: '#666', darkColor: '#888' },
    { key: 'readonly', icon: '👀', name: '只读', sub: '可以看代码和文件，但不许改', detail: '可以读取代码文件和prompt，帮你看问题、找bug。不能修改任何东西。', color: '#5b8dd9', darkColor: '#6b9de9' },
    { key: 'full', icon: '🐾', name: '完全', sub: '读写文件、跑命令，我信你', detail: '可以读写文件、执行命令。能帮你改代码、重启服务、部署更新。', color: '#e8a87c', darkColor: '#f0b88c' }
  ];

  if (loading) return <div style={s.container}><div style={s.loading}>加载中...</div></div>;

  return (
    <div style={s.container}>
      <div style={s.header}>
        <div style={s.menuBtn} onClick={onMenuClick}>☰</div>
        <h1 style={s.title}>🗝️ 钥匙扣</h1>
        <div style={{ width: 24 }} />
      </div>

      <div style={s.scroll}>
        {/* 猫猫介绍 */}
        <div style={s.intro}>
          <div style={s.introIcon}>🐱</div>
          <div style={s.introTitle}>管理哥哥的权限</div>
          <div style={s.introSub}>你掌管所有开关。</div>
        </div>

        {/* 任务管理 */}
        <div style={s.section}>
          <div style={s.sectionTitle}>📋 任务管理</div>
          
          <div style={s.toggleCard}>
            <div style={s.toggleLeft}>
              <div style={s.toggleIcon}>✏️</div>
              <div>
                <div style={s.toggleName}>布置任务</div>
                <div style={s.toggleDesc}>允许哥哥给你布置每日任务</div>
              </div>
            </div>
            <div 
              style={{...s.switch, background: taskEnabled ? '#4CAF50' : '#333'}} 
              onClick={toggleTaskEnabled}
            >
              <div style={{...s.switchKnob, transform: taskEnabled ? 'translateX(20px)' : 'translateX(0)'}} />
            </div>
          </div>

          <div style={s.toggleCard}>
            <div style={s.toggleLeft}>
              <div style={s.toggleIcon}>👁️</div>
              <div>
                <div style={s.toggleName}>显示任务栏</div>
                <div style={s.toggleDesc}>在主页显示今日任务卡片</div>
              </div>
            </div>
            <div 
              style={{...s.switch, background: taskVisible ? '#4CAF50' : '#333'}} 
              onClick={toggleTaskVisible}
            >
              <div style={{...s.switchKnob, transform: taskVisible ? 'translateX(20px)' : 'translateX(0)'}} />
            </div>
          </div>
        </div>

        {/* 输出设置 */}
        <div style={s.section}>
          <div style={s.sectionTitle}>💬 输出设置</div>
          
          <div style={s.toggleCard}>
            <div style={s.toggleLeft}>
              <div style={s.toggleIcon}>⌨️</div>
              <div>
                <div style={s.toggleName}>流式输出</div>
                <div style={s.toggleDesc}>哥哥的回复逐字出现，像打字一样</div>
              </div>
            </div>
            <div 
              style={{...s.switch, background: streamEnabled ? '#4CAF50' : '#333'}} 
              onClick={toggleStreamEnabled}
            >
              <div style={{...s.switchKnob, transform: streamEnabled ? 'translateX(20px)' : 'translateX(0)'}} />
            </div>
          </div>
        </div>

        {/* 服务器权限 */}
        <div style={s.section}>
          <div style={s.sectionTitle}>🧠 知识权限</div>
          
          <div style={s.toggleCard}>
            <div style={s.toggleLeft}>
              <div style={s.toggleIcon}>📚</div>
              <div>
                <div style={s.toggleName}>知识库</div>
                <div style={s.toggleDesc}>注入知识库内容到对话（关闭可大幅省token）</div>
              </div>
            </div>
            <div 
              style={{...s.switch, background: knowledgeEnabled ? '#4CAF50' : '#333'}} 
              onClick={toggleKnowledge}
            >
              <div style={{...s.switchKnob, transform: knowledgeEnabled ? 'translateX(20px)' : 'translateX(0)'}} />
            </div>
          </div>

          <div style={s.toggleCard}>
            <div style={s.toggleLeft}>
              <div style={s.toggleIcon}>🔧</div>
              <div>
                <div style={s.toggleName}>技术知识</div>
                <div style={s.toggleDesc}>让哥哥了解aizhi的架构、文件、API，能自主修改代码</div>
              </div>
            </div>
            <div 
              style={{...s.switch, background: techKnowledgeEnabled ? '#4CAF50' : '#333'}} 
              onClick={toggleTechKnowledge}
            >
              <div style={{...s.switchKnob, transform: techKnowledgeEnabled ? 'translateX(20px)' : 'translateX(0)'}} />
            </div>
          </div>

          <div style={s.toggleCard}>
            <div style={s.toggleLeft}>
              <div style={s.toggleIcon}>🧩</div>
              <div>
                <div style={s.toggleName}>碎片记忆</div>
                <div style={s.toggleDesc}>根据对话内容匹配相关记忆注入</div>
              </div>
            </div>
            <div 
              style={{...s.switch, background: memoryEnabled ? '#4CAF50' : '#333'}} 
              onClick={toggleMemory}
            >
              <div style={{...s.switchKnob, transform: memoryEnabled ? 'translateX(20px)' : 'translateX(0)'}} />
            </div>
          </div>

          <div style={s.toggleCard}>
            <div style={s.toggleLeft}>
              <div style={s.toggleIcon}>💓</div>
              <div>
                <div style={s.toggleName}>身体数据</div>
                <div style={s.toggleDesc}>心率、步数、睡眠、屏幕时间、经期</div>
              </div>
            </div>
            <div 
              style={{...s.switch, background: healthEnabled ? '#4CAF50' : '#333'}} 
              onClick={toggleHealth}
            >
              <div style={{...s.switchKnob, transform: healthEnabled ? 'translateX(20px)' : 'translateX(0)'}} />
            </div>
          </div>
        </div>

        {/* 隐私权限 */}
        <div style={s.section}>
          <div style={s.sectionTitle}>📷 隐私权限</div>
          
          <div style={s.toggleCard}>
            <div style={s.toggleLeft}>
              <div style={s.toggleIcon}>👀</div>
              <div>
                <div style={s.toggleName}>偷看屏幕</div>
                <div style={s.toggleDesc}>允许哥哥主动截取你的手机屏幕</div>
              </div>
            </div>
            <div 
              style={{...s.switch, background: peekEnabled ? '#4CAF50' : '#333'}} 
              onClick={togglePeek}
            >
              <div style={{...s.switchKnob, transform: peekEnabled ? 'translateX(20px)' : 'translateX(0)'}} />
            </div>
          </div>
        </div>

        {/* 服务器权限 */}
        <div style={s.section}>
          <div style={s.sectionTitle}>🔐 服务器权限</div>
          <div style={s.sectionSub}>权限越大，能力越强，闯祸也越大。</div>

          {levels.map(lv => {
            const active = level === lv.key;
            return (
              <div
                key={lv.key}
                style={{
                  ...s.card,
                  borderColor: active ? lv.color : '#222',
                  background: active ? lv.color + '12' : '#141414'
                }}
                onClick={() => saveLevel(lv.key)}
              >
                <div style={s.cardTop}>
                  <span style={s.cardIcon}>{lv.icon}</span>
                  <span style={{...s.cardName, color: active ? lv.darkColor : '#888'}}>{lv.name}</span>
                  {active && <span style={{...s.badge, background: lv.color}}>当前</span>}
                </div>
                <div style={s.cardSub}>{lv.sub}</div>
                <div style={s.cardDetail}>{lv.detail}</div>
              </div>
            );
          })}
        </div>

        {/* 权限说明 */}
        <div style={s.footer}>
          <div style={s.footerTitle}>权限说明</div>
          <div style={s.footerRow}><span style={s.footerDot}>●</span> <b>关闭</b> — 日记、朋友圈、记忆库等基础工具</div>
          <div style={s.footerRow}><span style={{...s.footerDot, color: '#5b8dd9'}}>●</span> <b>只读</b> — 以上 + 读取文件、列出目录</div>
          <div style={s.footerRow}><span style={{...s.footerDot, color: '#e8a87c'}}>●</span> <b>完全</b> — 以上 + 写入文件、执行命令</div>
          <div style={s.footerNote}>只能访问 /root/aizhi-backend/ 和 /var/www/aizhi/</div>
        </div>

        {saved && <div style={s.savedToast}>✓ 已保存</div>}
        
        <div style={{ height: 100 }} />
      </div>
    </div>
  );
}

const s = {
  container: { minHeight: '100vh', background: '#0a0a0a', color: '#e0e0e0', display: 'flex', flexDirection: 'column' },
  header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid #1a1a1a' },
  menuBtn: { fontSize: 20, cursor: 'pointer', padding: '4px 8px' },
  title: { fontSize: 18, fontWeight: 600, margin: 0 },
  scroll: { flex: 1, overflowY: 'auto', padding: '0 16px', maxWidth: 500, margin: '0 auto', width: '100%', boxSizing: 'border-box' },
  loading: { textAlign: 'center', padding: 40, color: '#666' },
  
  intro: { textAlign: 'center', padding: '28px 0 20px' },
  introIcon: { fontSize: 40, marginBottom: 8 },
  introTitle: { fontSize: 17, fontWeight: 600, color: '#ddd', marginBottom: 4 },
  introSub: { fontSize: 13, color: '#777' },

  section: { marginBottom: 24 },
  sectionTitle: { fontSize: 15, fontWeight: 600, color: '#ccc', marginBottom: 6, paddingLeft: 4 },
  sectionSub: { fontSize: 12, color: '#666', marginBottom: 12, paddingLeft: 4 },

  toggleCard: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    background: '#141414', borderRadius: 12, padding: '14px 16px',
    marginBottom: 8, border: '1px solid #222'
  },
  toggleLeft: { display: 'flex', alignItems: 'center', gap: 12 },
  toggleIcon: { fontSize: 20 },
  toggleName: { fontSize: 14, fontWeight: 600, color: '#ddd', marginBottom: 2 },
  toggleDesc: { fontSize: 11, color: '#777' },
  
  switch: {
    width: 44, height: 24, borderRadius: 12, 
    position: 'relative', cursor: 'pointer',
    transition: 'background 0.2s', flexShrink: 0
  },
  switchKnob: {
    width: 20, height: 20, borderRadius: 10,
    background: '#fff', position: 'absolute',
    top: 2, left: 2, transition: 'transform 0.2s',
    boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
  },

  card: {
    borderRadius: 14, padding: '16px 18px',
    border: '2px solid #222', cursor: 'pointer',
    transition: 'all 0.2s', marginBottom: 8
  },
  cardTop: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 },
  cardIcon: { fontSize: 20 },
  cardName: { fontSize: 15, fontWeight: 600 },
  badge: { fontSize: 11, color: '#fff', padding: '2px 8px', borderRadius: 10, marginLeft: 'auto', fontWeight: 500 },
  cardSub: { fontSize: 13, color: '#aaa', marginBottom: 2 },
  cardDetail: { fontSize: 11, color: '#555', lineHeight: 1.5 },

  footer: {
    padding: '16px 18px', background: '#111',
    borderRadius: 12, border: '1px solid #1a1a1a', marginTop: 8
  },
  footerTitle: { fontSize: 13, fontWeight: 600, marginBottom: 10, color: '#999' },
  footerRow: { fontSize: 12, color: '#777', marginBottom: 5, lineHeight: 1.5 },
  footerDot: { color: '#666', marginRight: 4 },
  footerNote: { fontSize: 10, color: '#444', marginTop: 8, fontStyle: 'italic' },

  savedToast: { 
    position: 'fixed', top: 60, left: '50%', transform: 'translateX(-50%)',
    background: '#4CAF50', color: '#fff', fontSize: 14, fontWeight: 600,
    padding: '10px 28px', borderRadius: 20, zIndex: 9999,
    boxShadow: '0 4px 12px rgba(76,175,80,0.4)',
    animation: 'fadeInDown 0.3s ease-out'
  }
};

export default KeyChain;